<template>
<div>
<div>

  <div class="container live-messages" v-bind:class="{ roundright: ((isOwnPep && isDistance) === false) }">
    <div class="switch-container bottom-shadow">

      <div class="switch">
        <label>Route details</label>
      </div>

    </div>

    <div class="data-container" v-if="race.data">

      <div class="race-info-container">
        <div class="input-container">
          <label>Route Name:</label>
          <input type="text" v-model="routeName" placeholder="Cannot be empty!" v-bind:class="{ error: routeName.length === 0 }" maxlength="50">
        </div>

        <div class="input-container" v-show="showAdminContent">
          <label>Route group:</label>
          <input type="text" v-model="routeGroup" placeholder="">
        </div>

        <div class="input-container" v-show="showAdminContent">
          <label>Route endmessage:</label>
          <textarea v-model="endMessage" type="text" placeholder="" rows="3"/>
        </div>
        <div class="input-container" v-show="showAdminContent">
          <label>Route description:</label>
          <textarea v-model="description" type="text" placeholder="" rows="3" maxlength="500"/>
        </div>

        <div class="input-container">
          <label>Event Code:</label>
          <input type="text" v-bind:value="race['.key']" placeholder="-" disabled>
        </div>

        <div class="input-container">
          <label>Replace gpx:</label>
          <input type="file" accept=".gpx" name="gpxReplace" id="gpxReplace" class="inputfile" ref="gpxReplace" v-on:change="onGpxFileChange">
          <button v-on:click="replaceGpx" v-show="gpxfileSelected">Replace</button>
        </div>

        <div class="input-container">
          <label>{{getImagesLabel}}</label>
          <div class="image-box">
          <img :src="getImagePathRaceImages()" v-show="imageStatus !== null && imageStatus.raceImages.exist" class="image-view"/>
          <img :src="raceImages.filePreview" v-show="raceImages.fileSelected || raceImages.uploadSuccess" class="image-view"/>
          <img v-show="fileSelected" :src="filePreview" class="image-view"/>
          <div class="labels">

          <label>Route image</label>
          <label>Jpg file, aspect ratio 2:1</label>
          </div>
          <hr>
          <div class="loader" v-show="raceImages.requestLoading"></div>

          <label class="replace" v-show="!raceImages.requestLoading && !raceImages.uploadSuccess">Upload image:</label>
          <input type="file" v-show="!raceImages.requestLoading && !raceImages.uploadSuccess" accept="image/*" name="raceImages" id="raceImages" class="inputfile" ref="raceImages" v-on:change="(event) => onFileChange(event, 'raceImages')">
          <label class="uploadsuccess" v-show="raceImages.uploadSuccess">Upload success!</label>
          <label class="uploadsuccess" v-show="raceImages.imageRemoveSuccess">Image removed! Image might still show up on the user interface for a few hours because of it being in cache but that's normal. If you have a new image you can upload it now</label>
          <button v-show="raceImages.fileSelected && !raceImages.requestLoading" v-on:click="() => uploadImage('raceImages')">Upload image</button>
          <label v-show="raceImages.fileSelected && !raceImages.requestLoading" v-on:click="() => imageUploadCancel('raceImages')" class="cancel">Cancel</label>
          <label v-show="imageStatus !== null && imageStatus.raceImages.exist" class="cancel" v-on:click="() => removeFile('raceImages')">Remove image</label>
          </div>

          <div class="image-box">
          <img :src="getImagePathEventLogos()" v-show="imageStatus !== null && imageStatus.eventLogos.exist" class="image-view"/>
          <img :src="eventLogos.filePreview" v-show="eventLogos.fileSelected || eventLogos.uploadSuccess" class="image-view"/>
          <img v-show="fileSelected" :src="filePreview" class="image-view"/>
          <div class="labels">

          <label>Event logo</label>
          <label>Png file</label>
          </div>
          <hr>
          <div class="loader" v-show="eventLogos.uploadingFile"></div>

          <label class="replace" v-show="!eventLogos.uploadingFile && !eventLogos.uploadSuccess">Upload image:</label>
          <input type="file" v-show="!eventLogos.uploadingFile && !eventLogos.uploadSuccess" accept="image/*" name="eventLogos" id="eventLogos" class="inputfile" ref="eventLogos" v-on:change="(event) => onFileChange(event, 'eventLogos')">
          <label class="uploadsuccess" v-show="eventLogos.uploadSuccess">Upload success!</label>
          <label class="uploadsuccess" v-show="eventLogos.imageRemoveSuccess">Image removed! Image might still show up on the user interface for a few hours because of it being in cache but that's normal. If you have a new image you can upload it now</label>
          <button v-show="eventLogos.fileSelected && !eventLogos.uploadingFile" v-on:click="() => uploadImage('eventLogos')">Upload image</button>
          <label v-show="eventLogos.fileSelected && !eventLogos.uploadingFile" v-on:click="() => imageUploadCancel('eventLogos')" class="cancel">Cancel</label>
          <label v-show="imageStatus !== null && imageStatus.eventLogos.exist" class="cancel" v-on:click="() => removeFile('eventLogos')">Remove image</label>
          </div>

          <div class="image-box">
          <img :src="getImagePathEventIcons()" v-show="imageStatus !== null && imageStatus.eventIcons.exist" class="image-view"/>
          <img :src="eventIcons.filePreview" v-show="eventIcons.fileSelected || eventIcons.uploadSuccess" class="image-view"/>
          <img v-show="fileSelected" :src="filePreview" class="image-view"/>
          <div class="labels">

          <label>Event icon</label>
          <label>Png file</label>
          </div>
          <hr>
          <div class="loader" v-show="eventIcons.requestLoading"></div>

          <label class="replace" v-show="!eventIcons.requestLoading && !eventIcons.uploadSuccess">Upload image:</label>
          <input type="file" v-show="!eventIcons.requestLoading && !eventIcons.uploadSuccess" accept="image/*" name="eventIcons" id="eventIcons" class="inputfile" ref="eventIcons" v-on:change="(event) => onFileChange(event, 'eventIcons')">
          <label class="uploadsuccess" v-show="eventIcons.uploadSuccess">Upload success!</label>
          <label class="uploadsuccess" v-show="eventIcons.imageRemoveSuccess">Image removed! Image might still show up on the user interface for a few hours because of it being in cache but that's normal. If you have a new image you can upload it now</label>
          <button v-show="eventIcons.fileSelected && !eventIcons.requestLoading" v-on:click="() => uploadImage('eventIcons')">Upload image</button>
          <label v-show="eventIcons.fileSelected && !eventIcons.requestLoading" v-on:click="() => imageUploadCancel('eventIcons')" class="cancel">Cancel</label>
          <label v-show="imageStatus !== null && imageStatus.eventIcons.exist" class="cancel" v-on:click="() => removeFile('eventIcons')">Remove image</label>

          </div>
          <OwnPepsButton />


        </div>

      </div>
  </div>

    <BottomNav @nextPage="previousPage()" nText="Back" nColor="yellow" done="true" top="true" />
  </div>


  <MobileButton @previousPage="previousPage()" pText="Back" pColor="yellow" />


  <PepPoint v-if="selectedPepPointId && isDistance" isDistance />
  <PepPoint v-if="selectedPepPointId && !isDistance" />

</div>
  <div class="right-bar" v-if="isOwnPep && isDistance">
    <div style="width:100%;">
    <div class="switch-container bottom-shadow">

      <div class="switch">
        <label>Distance peps</label>
      </div>

    </div>
<div style="max-height:78vh;overflow-y: scroll; padding-right:10px; background-color: #F2F2F2; display:flex; flex-direction:column;">
  <div class="message-box" v-for="(item, key) in racePepPointsWoLocation" :key="item.key" v-bind:class="{active : item.key === selectedPepPointId}">
    <div class="message-box-circle">
      <label>{{(item.value.distanceLocation / 1000).toFixed(1)}}</label>
    </div>
    <div class="message-box-text">

    <label>
      {{item.value.message}}
    </label>
    </div>
    <div class="buttons">
      <img src="../img/ic_routeoptions_edit.svg" width="30px" height="30px" style="cursor:pointer" v-on:click="selectPep(item.key)" />
    </div>

<!--   <label>{{item.value.distanceLocation + 'm ' + item.value.message}}</label>
  <div>
  <button v-on:click="selectPep(item.key)">EDIT</button>
  <button v-on:click="removePep(item.key)">REMOVE</button>
  </div> -->
  </div>



</div>
<div style="display:flex; flex-direction:column; margin-top:10px;">

<div style="align-self:center;" v-on:click="createPep()">
      <label class="add-new-button">Add new pep</label>
    </div>
    </div>
</div>
<div>

  </div>

</div>
</div>

</template>

<script>
import Vue from 'vue/dist/vue.js'
import BottomNav from './BottomNav'
import MobileButton from './MobileButton'
import OwnPepsButton from './OwnPepsButton'
import PepPoint from './PepPoint'
import { store } from '../store/store'
import { mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import MapManager from '../helpers/mapManager'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

import Datepicker from 'vuejs-datepicker'
import VueTimepicker from 'vue2-timepicker'

import firebase from 'firebase'
import { imageStorage } from '../firebase'

import VoiceMessageListener from '../helpers/voiceMessageListener'
import Toasted from 'vue-toasted'
import axios from 'axios'

Vue.use(VueMoment, {
  moment
})

Vue.use(Toasted, {position: 'bottom-center', duration: 2000, theme: 'outline'})

const decimalFilter = function(value) {
  return (value / 1000).toFixed(1)
}

const { mapFields } = createHelpers({
  getterType: 'getInfoField',
  mutationType: 'updateInfoField',
})

export default {
  name: 'myRacesInformation',
  title: 'Runner - My Routes',
  components: {
    BottomNav,
    MobileButton,
    OwnPepsButton,
    PepPoint,
    Datepicker,
    VueTimepicker
  },
  filters: {
    decimal: decimalFilter
  },
  data() {
    return {
      vml: new VoiceMessageListener(),
      isRaceInfo: false,
      startAmPm: '',
      endAmPm: '',
      copy: require('../img/copy.svg'),
      copyPressed: false,
      fileSelected: false,
      uploadingFile: false,
      uploadSuccess: false,
      file: '',
      filePreview: '',
      gpxfileSelected: false,
      gpxuploadingFile: false,
      gpxuploadSuccess: false,
      gpxfile: '',
      filePath: 'raceImages',
      timeout: null,
      imageStatus: null,
      raceImages: {
        file: null,
        filePreview: null,
        fileSelected: false,
        requestLoading: false,
        uploadSuccess: false,
        imageRemoveSuccess: false,
      },
      eventLogos: {
        file: null,
        filePreview: null,
        fileSelected: false,
        requestLoading: false,
        uploadSuccess: false,
        imageRemoveSuccess: false,
      },
      eventIcons: {
        file: null,
        filePreview: null,
        fileSelected: false,
        requestLoading: false,
        uploadSuccess: false,
        imageRemoveSuccess: false,
      }
    }
  },
  asyncComputed: {
    showAdminContent() {
      return new Promise((resolve, reject) => {
        firebase.auth().currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          // Confirm the user is an Admin.
          if (idTokenResult.claims.admin) {
           resolve(true)
         } else {
           resolve(false)
         }
        })
        .catch((error) => {
          console.log(error)
          resolve(false)
        })
      })
    }
  },
  computed: {
    ...mapFields([
      'information'
    ]),
    ...mapGetters({
      race: "race",
      timezone: "timezone",
      selectedPepPointId: "selectedPepPointId",
      currentRaceId: "currentRaceId",
      isOwnPep: "isOwnPep",
      isDistance:"isDistance"
    }),

      endMessage: {
      get: function() {
        return this.information.endMessage

      },
      set: function(value) {
        this.$store.dispatch('setEndMessage', value)
        this.information.endMessage = value
      }
    },
    routeGroup: {
      get: function() {
        return this.information.routeGroup

      },
      set: function(value) {
        this.$store.dispatch('setRouteGroup', value)
        this.information.routeGroup = value
      }
    },
    description: {
      get: function() {
        return this.information.description

      },
      set: function(value) {
        this.$store.dispatch('setDescription', value)
        this.information.description = value
      }
    },
    routeName: {
      get: function() {
        return this.information.name

      },
      set: function(value) {
        this.information.name = value
        this.$store.dispatch('setRouteName', value)
      }
    },
    friendsLink() {
      return "https://friends.racepeps.com/#/races/" + this.race['.key']
    },
    startTime() {
      var time = moment()
      time.hours(this.information.start.time.HH)
      time.minutes(this.information.start.time.mm)
      return time.format('LT')
    },
    endTime() {
      var time = moment()
      time.hours(this.information.end.time.HH)
      time.minutes(this.information.end.time.mm)
      return time.format('LT')
    },
    getImagesLabel() {
      if (this.imageStatus === null) {
        return 'Images (fetching...):'
      } else {
        return 'Images:'
      }
    },
    routeImageSelected() {
      if (this.imageStatus !== null) {


      let a = this.imageStatus.hasOwnProperty('raceImages')
      if (a) {
        console.log(this.imageStatus.raceImages)
        let b = this.imageStatus.raceImages.hasOwnProperty('fileSelected')
        console.log(b)

      }
      console.log(a)
      }
      return false
     /*let a = this.imageStatus.hasOwnProperty('raceImages')
      console.warn(a)

      if (a) {
        let b = this.imageStatus.raceImages.hasOwnProperty('fileSelected')
        console.warn(b)
      }
      if (this.imageStatus === null) {
        return false
      } else if (this.imageStatus.hasOwnProperty('raceImages') && this.imageStatus.raceImages.hasOwnProperty('fileSelected')) {
        return true
      }
      return false*/
      console.log(this.imageStatus)
    },

    racePepPointsWoLocation: function () {
    if(this.race) {
      const obj = this.race.data.racePepPointsWoLocation
      if (obj === undefined) {
        return []
      }
      const objKeys = Object.keys(obj)
      console.log(objKeys)
      console.log(objKeys)
      const arr = objKeys.map(key => ({ key, value: obj[key] }));
      console.log(arr)
      console.log(_.orderBy(arr, 'value.distanceLocation'))
      return (_.orderBy(arr, 'value.distanceLocation'))

    return _.orderBy(this.race.data.racePepPointsWoLocation, 'distanceLocation')
  return null
    console.log(_.orderBy(this.race.data.racePepPointsWoLocation, 'value.distanceLocation'))
    } else {
      return null
    }
  },

  },
  mounted() {
    if(this.race) {
      this.vml.setUpMessages(this.race.data.live)
    }
    this.checkImageExists()

  },
  methods: {
    selectPep(id) {
      this.$store.dispatch('selectPepPoint', id)
    },
    removePep(id) {
      this.$store.dispatch('removePepPointWoLocation', id)
    },
    createPep() {
      this.$store.dispatch('addPepPointWoLocation').then((ref) => {
        this.selectPep(ref.key)
      })
    },
    c(event, isStart) {
      console.log(event)
      const { h, mm, a } = event.data
      if(isStart) {
        this.startAmPm = h + ':' + mm + ' ' + a
      } else {
        this.endAmPm = h + ':' + mm + ' ' + a
      }
    },
    liveSender(sender, type) {
      let value = sender
      if(type === 'A') {
        value = "Audio"
      } else if(!sender) {
        value = "Error"
      }
      return value
    },
    previousPage() {
      this.$router.replace('myRaces')
    },
    liveDate(timestamp) {
      return moment(timestamp * 1000).format()
    },
    copyLink() {
       var el = document.getElementById("link");

       if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
         var editable = el.contentEditable;
         var readOnly = el.readOnly;
         el.contentEditable = true;
         el.readOnly = false;
         var range = document.createRange();
         range.selectNodeContents(el);
         var sel = window.getSelection();
         sel.removeAllRanges();
         sel.addRange(range);
         el.setSelectionRange(0, 999999);
         el.contentEditable = editable;
         el.readOnly = readOnly;
       } else {
         el.select();
       }
       document.execCommand('copy');
       el.blur();
       Vue.toasted.show('Link copied to clipboard');
    },
    onFileChange(e, objectKey) {

      if (e.target.files.length === 0){
        this[objectKey].fileSelected = false
        this[objectKey].file = ''
      } else {
        this[objectKey].file = this.$refs[objectKey].files[0]
        this[objectKey].filePreview = URL.createObjectURL(this[objectKey].file)
        this[objectKey].fileSelected = true
      }
  },
  imageUploadCancel(objectKey) {
        this[objectKey].fileSelected = false
        this[objectKey].filePreview = ''
        this[objectKey].file = ''
        this.$refs[objectKey].value = ''
  },
  imageUploadClear(objectKey) {
        this[objectKey].fileSelected = false
        this[objectKey].file = ''
        this.$refs[objectKey].value = ''
  },
  onGpxFileChange(e) {
    if (e.target.files.length === 0){
        this.gpxfileSelected = false
        this.gpxfile = ''
      } else {
        this.gpxfile = this.$refs.gpxReplace.files[0]
        this.gpxfileSelected = true
      }
  },
  onFileTypeChange(e) {
    console.log(e.target.value)
    this.filePath = e.target.value
  },
  uploadImage(filePath) {

  const uid = firebase.auth().currentUser.uid
  var imageUploadRef = imageStorage.child(`${filePath}/uploads/${uid}/${this.race['.key']}`);

  this[filePath].requestLoading = true

imageUploadRef.put(this[filePath].file).then(snapshot => {
    console.log('Uploaded a blob or file!')
    this.imageUploadClear(filePath) //for clearing selection
    this[filePath].requestLoading = false
    this[filePath].uploadSuccess = true
    })

  /*setTimeout(() => {
  this.imageUploadClear(filePath) //for clearing selection
  this[filePath].uploadingFile = false
  this[filePath].uploadSuccess = true

  }, 1000)*/

  /*this.uploadingFile = true
  const uid = firebase.auth().currentUser.uid
  var imageUploadRef = imageStorage.child(`${filePath}/uploads/${uid}/${this.race['.key']}`);

  imageUploadRef.put(this.file).then(snapshot => {
    console.log('Uploaded a blob or file!')
    this.uploadingFile = false
    this.uploadSuccess = true
  })
*/
  },
  removeFile(imageType) {
    this[imageType].requestLoading = true
    console.log('wutum')

    firebase.auth().currentUser.getIdToken().then((token) => {
    const publicId = this.currentRaceId
    const url = `https://us-central1-racepeps.cloudfunctions.net/api/removeImage/${publicId}/${imageType}`
    console.log(url)
    let config = {
      headers: {
          Authorization: `Bearer ${token}`,
      }
    }

    axios.get(url, config).then(res => {
    this.imageUploadCancel(imageType)
    this[imageType].requestLoading = false
    this[imageType].imageRemoveSuccess = true
    this.imageStatus[imageType].exist = false
    }).catch((e) => {
    this[imageType].requestLoading = false

    })
    })
  },
  replaceGpx() {
    let publicId = this.currentRaceId

              firebase.auth().currentUser.getIdToken().then((token) => {

             var file = this.gpxfile

               var formData = new FormData();
                formData.append("public-id", publicId);
                formData.append("gpx", file);
                formData.append("raceGpx", true);
                //formData.append("timestamp", moment().utc("MM/DD/YYYY HH:MM").valueOf() / 1000)
                var xhr = new XMLHttpRequest();

                xhr.open("POST", "https://us-central1-racepeps.cloudfunctions.net/api/processReplaceGpx", true);

                xhr.setRequestHeader('Authorization', 'Bearer ' + token);

                xhr.onload = () => {
                    if (xhr.readyState === xhr.DONE) {
                        if (xhr.status === 200) {
                          alert('GPX replaced, reopen race!')

                        } else {
                          console.log("Failed to process gpx file");
                          alert('GPX replace failed')
                        }
                    }
                }

                xhr.onerror = (err) => {
                          alert('GPX replace failed')
                };

                xhr.send(formData);

            })

  },
  getImagePathEventIcons() {
    const raceId = this.race['.key']
    return `https://storage.googleapis.com/racepeps.appspot.com/eventIcons/data/${raceId}`
  },
  getImagePathEventLogos() {
    const raceId = this.race['.key']
    return `https://storage.googleapis.com/racepeps.appspot.com/eventLogos/data/${raceId}`
  },
  getImagePathRaceImages() {
    const raceId = this.race['.key']
    //const raceId = '-LrgzNexNXmXWVEEi_0m'
    return `https://storage.googleapis.com/racepeps.appspot.com/raceImages/data/${raceId}.jpg`
  },
  checkImageExists() {

    let imageStatus = {}
    //run get request to get information which images exists
    const eventIconsPath = this.getImagePathEventIcons()
    const eventLogosPath = this.getImagePathEventLogos()
    const raceImagesPath = this.getImagePathRaceImages()
    console.log(raceImagesPath)
    const checkEventIconsPath = axios.get(eventIconsPath)
    const checkEventLogosPath = axios.get(eventLogosPath)
    const checkRaceImagesPath = axios.get(raceImagesPath)

    Promise.allSettled([checkEventIconsPath, checkEventLogosPath, checkRaceImagesPath]).then(results => {

        for (const result of results) {
        const error = (result.status === 'rejected')
        let url
        if (error) {
          url = result.reason.response.request.responseURL
        } else {
          url = result.value.request.responseURL
        }

        if (url.includes('https://storage.googleapis.com/racepeps.appspot.com/eventLogos')) {
          imageStatus.eventLogos = {
            exist: !error
          }
        }
        if (url.includes('https://storage.googleapis.com/racepeps.appspot.com/eventIcons')) {
          imageStatus.eventIcons = {
            exist: !error
          }
        }
        if (url.includes('https://storage.googleapis.com/racepeps.appspot.com/raceImages')) {
          imageStatus.raceImages = {
            exist: !error
          }
        }
      }
      this.imageStatus = imageStatus
    })
    console.log(imageStatus)
//https://storage.googleapis.com/racepeps.appspot.com/raceImages/data/-LrhzndqMaaPcUa7Wm97.jpg
    /*axios.get(raceImagesPath).then(res => {
      console.log(res)
    }).catch((e) => {
      console.log('ei kuvaa')
      console.log(e)
    })*/

  }
  }

}
</script>

<style lang="scss">
  @media screen and (max-width: 1140px) {
    .map-container {
      bottom: 200px !important;
    }
  }
</style>

<style lang="scss" scoped>
@import '../styles/styles.scss';

input[type="text"][disabled] {
   color: black;
}

textarea[type="text"][disabled] {
   color: black;
}
.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left:5px;
  align-self:center;
}

  .right-bar {
    position: fixed;
    width: 500px;
    left: 22em;
    top: 3vh;
    height: 90vh;
    border-bottom-right-radius: 20px;
    border-top-right-radius: 20px;
    overflow: hidden;
    background-color:white;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content: space-between;

  }

.data-container {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
    background-color: white;
    padding: 20px;
    height: auto;
    overflow-y: auto;
}

.info-text {
  font-size: 17px;
  color: $cyan-dark;
}

.date-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100px;

  label {
    font-size: $font-medium;
    margin-bottom: 10px;
  }

  .date-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 10 0;

    input {
      margin: 0;
    }
  }

}

.row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
}

.description-row {

    textarea {
        width: 100%;
        resize: none;
    }
}

.live-row {
    display: flex;
    flex-direction: row;
    margin-bottom: 12px;
    align-items: center;
    min-height: 30px;

    .live-sender {
      margin-right: 5px;
      font-weight: 700;
    }

    .live-time {
      font-size: 12px;
      opacity: 0.7;
      margin-right: 5px;
    }

    .live-audio-container {
      margin-left: 5px;
    }

    img {
      width: 30px;
      height: 30px;
      display: flex;
      align-self: center;
      cursor: pointer;
    }
}

.info-text {
  font-size: 17px;
  color: $cyan-dark;
}

.name-row {
    align-items: center;

    .name {
        margin-right: 5px;
        font-size: $font-semiSemiLarge;
        color: $cyan;
    }
    .length {
        font-size: $font-medium;
    }
}

.header {
    height: 40px;
    font-size: $font-semiLarge;
    display: flex;

    img {
      cursor: pointer;
      height: 40px;
      width:40px;
    }
}

.no-messages {
  display: flex;
  align-self: center;
}

.loader {
  padding: 3px !important;
  margin-top: 20px;
  margin-bottom:20px;
  width: 50px !important;
  height: 50px !important;
  align-self:center;
}

.friendLink {
  color: $cyan;
  width: 100%;
}

.input-container.date-info {
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  input {
    width: 100px;
    margin-left: 10px;
  }

  textarea {
    width: 100%;
  }
}

.input-container.tracking-info {


  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 30px;
  margin-top: 20px;

  .tracking-on {
    color: $green;
    margin-left: 10px;
    font-weight: bold;
    font-size: 18px;
  }

  .tracking-off {
    color: $red;
    margin-left: 10px;
    font-size: 18px;
    font-weight: bold;
  }

}

.info-dates-container {
  margin: 30px 0px;
}

.switch-container {
  display:flex;
	flex-direction: row;
	width: 100%;
}

.switch {
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
  background-color: $cyan;
	color: white;
	padding-top: 5px;
	padding-bottom: 5px;
  cursor: pointer;
  height: 30px;

	label {
		font-size: $font-semiSemiLarge;
    cursor: pointer;
	}
}

.switch.selected {
	background-color: $green;
}

.image-container {
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 30px;
    height: 30px;
  }
}
.message-box {
  display:flex;
  flex-direction:row;
  flex:1;
  padding:10px;
  margin-top:20px;
  background-color: $grey;
}

.message-box-circle {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background-color: $cyan;
  display: flex;
  justify-content:center;
  align-items:center;
  label {
    color: $white;
  }
}
.message-box-text {
  display: flex;
  margin-left:10px;
	font-size: $font-medium;
  padding:10px;
  background-color:white;
  border-radius:20px;
  flex:1;
}

.image-box {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 10px;
  border-color: $grey;
  background-color: $grey;
  display:flex;
  flex-direction: column;
  .labels {
    display:flex;
    flex-direction: column;
    margin-left: 5px;
  }
  .labels label {
    margin-top: 10px;
  }
  .labels label:last-child {
  margin-bottom:10px;
  }

  hr {
    width:95%;
    border-top: 2px dashed $cyan;
  }
  label.replace {
    margin-top:5px;
    margin-left:5px;
  }
  label.uploadsuccess {
    margin-top:5px;
    margin-left:5px;
    margin-bottom:10px;
  }
  label.cancel {
    margin-top:10px;
    cursor: pointer;
    text-align: center;
    color: $cyan;
    text-decoration: underline;
  }
}

.image-view {
  max-width: 100%;
  align-self:center;
}

.add-new-button {
  text-decoration: underline;
  cursor:pointer;
  color: $cyan;
  font-size: $font-semiLarge;
}

@media screen and (min-width: 1140px) {
  .header {
    height: 80px;
    font-size: 24px;
  }

  .switch {
    height: 50px;

    label {
  		font-size: $font-large;
  	}
  }
}
</style>
